export default "__VITE_ASSET__97083c08__"